import React from 'react';
import * as S from './TimeDropdown.styles';
import { convert12To24Format, generateTimeList, getTodaysDate } from "../../../../../shared/config/utils";
interface ITime {
  date: Date;
  time: string;
  updateTime: (time, isPickup) => void;
  isPickup: boolean;
  initialTime?: Date
  pickupTime?: string;
  pickupDate?: Date;
}

const TimeDropdown: React.FC<ITime> = ({
  date = new Date(),
  time = '',
  updateTime = () => {},
  isPickup = true,
  initialTime = null,
  pickupTime = '',
  pickupDate = new Date(),
}) => {
  const isToday = new Date().toDateString() === date.toDateString();
  let timeList = generateTimeList();
  if (isToday) {
    const defaultDate = getTodaysDate();
    timeList = generateTimeList(defaultDate.getHours(), defaultDate.getMinutes());
  }
  if (initialTime) {
    const loc = timeList.indexOf(initialTime);
    timeList = timeList?.filter((_, index) => index >= loc);
  }
  if (!isPickup && pickupTime) {

    const timeIn24HourFormat = convert12To24Format(pickupTime);
    const [pickupHour, pickupMinute] = timeIn24HourFormat.split(':').map(Number);

    const pickupDateTime = new Date(pickupDate);
    pickupDateTime.setHours(pickupHour);
    pickupDateTime.setMinutes(pickupMinute);
  
    const minDropDateTime = new Date(pickupDateTime.getTime() + 12 * 60 * 60 * 1000);
  
    if (pickupDate.toDateString() === date.toDateString()) {
      timeList = timeList.filter(time => {
        const timeIn24HourFormat = convert12To24Format(time);
        const [hour, minute] = timeIn24HourFormat.split(':').map(Number);
  
        const dropDateTime = new Date(date);
        dropDateTime.setHours(hour);
        dropDateTime.setMinutes(minute);
  
        return dropDateTime >= minDropDateTime;
      });
    }
  }
  return (
    <S.TimeDropdown>
      <ul>
        {timeList.map((data, index) => <li key={'timer' + index} onClick={()=> updateTime(data, isPickup)}><span>{data}</span>{data === time ? <S.TickIcon >&#10003;</S.TickIcon> : null}</li>) || null}
      </ul>
    </S.TimeDropdown>
  );
};
export default React.memo(TimeDropdown);